import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { toSearchWords } from '../../../utils/searchText';
import { keys } from './keys';
import type { InboxEmailStatus } from '../types/inbox.types';

async function fetchInboxEmailsCount(spaceId: string, status: InboxEmailStatus | undefined, search: string) {
  let query = apiClient
    .from('inbox_emails')
    .select('id', { count: 'exact', head: true })
    .eq('space_id', spaceId);

  if (status) {
    query = query.eq('status', status);
  }

  for (const word of toSearchWords(search)) {
    query = query.ilike('search_text', `%${word}%`);
  }

  const { count, error } = await query;

  if (error) {
    throw error;
  }

  return count ?? 0;
}

type Params = {
  spaceId?: string;
  status?: InboxEmailStatus;
  search?: string;
};

export function useGetInboxEmailsCount(params: Params) {
  const spaceId = params.spaceId;
  const search = params.search?.trim() ?? '';

  return useQuery({
    queryKey: search
      ? keys.countSearch(spaceId ?? '', params.status, search)
      : keys.count(spaceId ?? '', params.status),
    queryFn: () => fetchInboxEmailsCount(spaceId!, params.status, search),
    enabled: Boolean(spaceId),
  });
}
